import "./_table-shell.scss";

/**
 * Header (title + optional action) around a table body. Composition over
 * configuration: pass the actual <Table> (or anything else) as children
 * instead of threading table props through this component.
 */
const TableShell = ({ title, action, className = "", children }) => (
  <div className={`table-shell ${className}`.trim()}>
    <div className="table-shell__head">
      <p className="table-shell__title">{title}</p>
      {action && <div className="table-shell__action">{action}</div>}
    </div>
    <div className="table-shell__body">{children}</div>
  </div>
);

export default TableShell;
